export const getTextForDevice = (
  deviceResolution: boolean,
  textForDevice: string | undefined,
  text: string | undefined
) => {
  return deviceResolution && textForDevice ? textForDevice : text
}
